import {Col, DropdownItem, FormGroup} from "reactstrap";
import React, {useEffect, useState} from "react";
import dynamic from "next/dynamic";
import moment from "moment";
import {getSessionId} from "../../../../services/session";
import {useQuery} from "@apollo/client";
import GET_USER from "../../../../graphql/queries/user";

let DatePicker = dynamic(
    () => import("../../../../components/Camper/DatePicker"),
    {ssr: false}
);

interface DateProps {
    date: moment.Moment
    setDate: (date: moment.Moment) => void
    isOutsideRange: (date: moment.Moment) => boolean
    placeHolderText: string
    pickerId: string
    findSelectedDate: (camperFilter) => moment.Moment
    loadFromLastSelectedFilter?: boolean
}

const Date = ({date, setDate, isOutsideRange, placeHolderText, pickerId, findSelectedDate, loadFromLastSelectedFilter}: DateProps) => {
    const sessionId = getSessionId();
    const {loading, error, data, client} = useQuery(GET_USER, {
        variables: {
            uuid: sessionId,
        },
    });

    useEffect(() => {
        if (!loadFromLastSelectedFilter) {
            return;
        }

        if (data && data.user && data.user.lastSelectedCamperFilter) {
            setDate(findSelectedDate(data.user.lastSelectedCamperFilter));
        }
    }, [data])

    return (
        <>
            <FormGroup>
                <div className="dropdown-item">
                    <DatePicker
                        initialDate={date}
                        placeHolderText={placeHolderText}
                        pickerName={pickerId}
                        onDateChange={setDate}
                        isOutsideRange={isOutsideRange}
                    />
                </div>
            </FormGroup>
        </>
    )
}

export default Date;
